import styled from 'styled-components'
import { styled as muiStyled } from '@mui/system'

export const MoreGoalsContainer = muiStyled('div')(
  ({ theme }) => `
    display:flex;
    flex-direction:column;
`,
)

export const OrgainzationGoalsContainer = muiStyled('div')(
  ({ theme }) => `
  padding: 15px 15px;
  margin: 0 auto;  
  @media (min-width: 768px) {
        padding: 10px 100px;
    }
`,
)
